

    if (!window.isUndefined) {
        window.isUndefined = function(value) {
        return typeof value === "undefined"
        }
        }
        if (!window.isDefined) {
        window.isDefined = function(value) {
        return typeof value !== "undefined"
        }
        }
        if (!window.isValue) {
        window.isValue = function(value) {
        return window.isDefined(value) && value && value !== ""
        }
        }

!(function (t, a) {
    function e(t) {
        (this.baseUrl = "https://cdn.shopify.com/s/files/1/2220/8601/files/"), (this.domain = t.replace(".myshopify.com", "")), (this.productSwatches = []), (this.productsPerRow = 4);
    }
    (e.prototype.setProductsPerRow = function (t) {
        this.productsPerRow = t;
    }),
        (e.prototype.productHasColorOption = function (t) {
            if (!window.isValue(t.options_with_values)) return !1;
            for (var a = 0; a < t.options_with_values.length; a++) {
                if ("color" === t.options_with_values[a].name.toLowerCase()) return !0;
            }
            return !1;
        }),
      
        (e.prototype.addProductSwatchBox = function (t, a) {
            this.productSwatches[t] = a;
        }),
        (e.prototype.getSwatchesJson = function (t) {
       
            if (!1 === window.isValue(t.swatches))return !1;
            var a = t.swatches;
        
            return !(a.length < 2) && a;
        }),
        (e.prototype.swapProductSwatchBox = function (a, e) {
            if (!window.isValue(this.productSwatches[e])) return !1;
            for (var r = t(a), o = t(this.productSwatches[e]), c = r.find(".product_item_swatches").detach(), s = [1, 2, 3], i = 0; i < s.length; i++) o.removeClass("per-" + s[i] + "-row");
            o.addClass("per-" + this.productsPerRow + "-row"), r.replaceWith(o), c.appendTo(o.find(".info"));
        }),
      
        (e.prototype.buildProductSwatchBox = function (a) {
          if(a != undefined){
            var e = "/products/" + a,
                r = this;
          
            $.get(e, { view: "swatch" }, function (a) {
                var e = $.parseJSON(a),
                    o = r.getSwatchesJson(e);
            
                if (!window.isValue(o)) return !1;
                for (var c = t('<div class="product_item_swatch_color">'), s = t('<ul class="product_item_swatches">'), i = 0; i < o.length; i++) {
                    var n = o[i],
                        l = 'https://cdn.shopify.com/s/files/1/2220/8601/files/' + n.color.replace(/\s+/g, '-') + '.png',
                        p = t('<li class="swatch">'),
                        d = t('<a class="swatch_link">');
               
                    d.attr("data-handle", n.handle),
                        d.attr("data-option-name", n.option_name),
                        d.attr("href", n.url),
                        d.css("background-color", n.color),
                        d.css("background-image", "url(" + l + ")"),
                        d.text(n.color),
                        p.append(d),
                        s.append(p);
              
                }
                var u = o[0].color,
                    h = o[0].option_name;
                c.html('<p><span class="label">' + h + ': </span><span class="current_swatch">' + u + "</span></p>"), s.find("li:first").addClass("active");
                var w = t(".product_related_swatches");
                w.append(c),
                    w.append(s),
                    t(".swatch").hover(
                        function () {
                            t(".product_item_swatch_color .current_swatch").text(t(this).text()), t(".product_item_swatch_color span.label").text(t(this).find(".swatch_link").data("option-name") + ": ");
                        },
                        function () {
                            t(".product_item_swatch_color .current_swatch").text(u), t(".product_item_swatch_color span.label").text(h + ": ");
                        }
                    );
            });
          }            
        }),
        (window.swatchBox = new e(a.shop));
})(window.jQuery, window.Shopify);

var product_handle = $('product-variants').attr('handle'); 

if (window.isValue(window.swatchBox)) {
 
         window.swatchBox.buildProductSwatchBox(product_handle);

 }

function related_swatches(){
  console.log('related_swatches');
var inventoryEls = document.querySelectorAll(".product-item");
if (inventoryEls.length) {
    $( ".product-item" ).each(function( index, prod ) {
      var current = $(this);
      // This is the variant ID we placed on the DIV
      var variantId = $(this).attr('data-variant_id'); 
   

      var data_handle = $(this).attr('data-handle');
      var currentProductTitle = $(this).find(".product-item-meta .product-item-meta__title").text();
    
      // Now we use the product's URL to call Shopify and fetch the product.swatch.liquid
      // template. 
      $.get('/products/'+data_handle + "?view=swatch", function(data, status){
         var pro_data = JSON.parse(data);
     
     
        var prodData = data;
       
        var swatchData = pro_data.swatches;
        console.log(swatchData);
        var dataTagHotseller = 0;
         var dataTagOutlet = 0;
        var init = 0;
         if(swatchData.length > 1){
            var indexx = 0;
           var hotSellerIndex = 0;
           var priceLabelIndex = 0;
        current.find('.product_item_swatches').html('');
            $('[data-custom='+variantId+']').html('');
       $.each(swatchData, function(){
        var dataTagHotseller = 0;
         var  dataTagOutlet = 0;
         var j = 0;
         var k = 0;
         var c = ('<div class="product_item_swatch_color">');
         var s = ('<ul class="product_item_swatches">');
         var n = swatchData[init];
         var l = 'https://cdn.shopify.com/s/files/1/2220/8601/files/' + swatchData[init].color.replace(/\s+/g, '-') + '.png';
         var p = ('<li class="swatch">');
        var d = ('<a class="swatch_link">');
         var swatchAvailability = swatchData[init].productFilterData.available;
         console.log(swatchData[init].handle);
     $('swatch_link').attr("data-handle", swatchData[init].handle),
        $('swatch_link').attr("data-option-name", swatchData[init].option_name),
         $('swatch_link').attr("href", swatchData[init].url),
         $('swatch_link').css("background-color", swatchData[init].color),
        $('swatch_link').css("background-image", "url(" + l + ")"),
        $('swatch_link').text(swatchData[init].color),
         $('swatch').append(d);
         var filteredPrice = parseFloat(swatchData[init].originalPrice.replace("$", "")).toFixed(2);
         var filteredMainPrice = parseFloat(swatchData[init].price.replace("$", "")).toFixed(2);
        
          if(indexx == 0 && swatchAvailability == false)
          {
              $('[data-imageId='+variantId+']').append('<div class="sold_out_product ng-scope"><span class="getonthelist">WAITLIST</span></div>'); 
              $('[data-variant_id='+variantId+']').addClass("sold-out");  
          }
    
          $.each(swatchData[init].tags,function()
                 {
                   if(swatchData[init].tags[j] == '#hotseller')
                   {
                      dataTagHotseller = 1;
                     return;
                   }
                   j++;
                 });
            $.each(swatchData[init].tags,function()
                 {
                   if(swatchData[init].tags[k] == 'OUTLET-$5' || swatchData[init].tags[k] == 'OUTLET-$10' || swatchData[init].tags[k] == 'OUTLET-$15' || swatchData[init].tags[k] == 'OUTLET-$20')
                   {
                      dataTagOutlet = 1;
                     return;
                   }
                 
                   k++;
                 }); 
            if(hotSellerIndex == 0)
          {
            if(dataTagHotseller == 0 && dataTagOutlet == 0)
            {
              $('.hotseller[data-hotSeller='+variantId+']').addClass("displayNone");	
              $('.hotseller[data-hotSeller='+variantId+']').removeClass("displayBlock");
                $('.discount-image[data-priceLabel='+variantId+']').removeClass("displayBlock");	
                 $('.discount-image[data-priceLabel='+variantId+']').addClass("displayNone");
            }else if(dataTagHotseller == 0 && dataTagOutlet == 1)
            {
              $('.hotseller[data-hotSeller='+variantId+']').addClass("displayNone");	
              $('.hotseller[data-hotSeller='+variantId+']').removeClass("displayBlock");
                $('.discount-image[data-priceLabel='+variantId+']').removeClass("displayNone");	
                 $('.discount-image[data-priceLabel='+variantId+']').addClass("displayBlock");
            }
          else if(dataTagHotseller == 1 && dataTagOutlet == 0)
          {
            $('.hotseller[data-hotSeller='+variantId+']').addClass("displayBlock");	
              $('.hotseller[data-hotSeller='+variantId+']').removeClass("displayNone");
                $('.discount-image[data-priceLabel='+variantId+']').removeClass("displayBlock");	
                 $('.discount-image[data-priceLabel='+variantId+']').addClass("displayNone");
          } else if(dataTagHotseller == 1 && dataTagOutlet == 1)
          {
            $('.hotseller[data-hotSeller='+variantId+']').addClass("displayNone");	
              $('.hotseller[data-hotSeller='+variantId+']').removeClass("displayBlock");
                $('.discount-image[data-priceLabel='+variantId+']').removeClass("displayNone");	
                 $('.discount-image[data-priceLabel='+variantId+']').addClass("displayBlock");
          }
        }
        
        if(currentProductTitle == swatchData[init].title){          
          var productPLPClass = "active";
        }else{
          var productPLPClass = "";
        }
          
          $('[data-custom='+variantId+']').append('<li class="swatch '+ productPLPClass +'" title="' + swatchData[init].color + '"><a class="swatch_link" data-mainProductId="'+ swatchData[init].productFilterData.id  +'" data-mainProducUrl="'+ swatchData[init].productFilterData.handle  +'" data-tagHotseller="'+ dataTagHotseller +'" data-tagOutlet="'+ dataTagOutlet +'" data-availability="'+ swatchData[init].productFilterData.available +'" data-imageURL="' + swatchData[init].image.url.replace("_large", "_1000x") +'" data-variantTitle="' + swatchData[init].title +'" data-variantHandleUrl="' + swatchData[init].url +'" data-OriginalPrice="$ ' + filteredPrice  +'" data-Price="$ ' + filteredMainPrice +'" data-forImage="' + variantId + '" style="background-image: url('+ l +');"></a></li>');
      
          init ++;
           indexx++;
          hotSellerIndex++;
        });
          }
          else if(swatchData.length <= 1) {
             var swatchAvailability = swatchData[init].productFilterData.available;
             if(swatchAvailability == false)
                    {
              $('[data-imageId='+variantId+']').append('<div class="sold_out_product ng-scope"><span class="getonthelist">WAITLIST</span></div>'); 
              $('[data-handleid='+variantId+']').addClass("sold-out");  
                }
           
          }
         
          
          $.each(swatchData, function(index, variant) { 
            
            if(data_handle == variant.handle){
             
              if (variant.productFilterData.variants.length) {
                   var xLeft = 0;
                   $.each(variant.productFilterData.variants, function(index, size_options) { 
                     var xVariant = size_options;
                        if (xVariant.available && xVariant.inventory_management === 'shopify') {
                          xLeft += parseInt(xVariant.inventory_quantity);
                         } 
                   });
                   if (xLeft > 0 && xLeft < 5) {
                    $('[data-lowstock='+variantId+']').html('only ' + xLeft + ' left');
                    }
              }
            }
        });
   
    
      }); 

    
  });
}
}



$(document).on('click','.swatch_link',function()
{ 
    var current =  $(this);
  var mainProductId = $(this).attr("data-mainproductid");
  var mainProductUrl = $(this).attr("data-mainProducUrl");
  var imageURL = $(this).attr("data-imageurl");
  var variantTitle = $(this).attr("data-variantTitle");
  var variantUrl = $(this).attr("data-variantHandleUrl");
  var dataOriginalPrice = $(this).attr("data-originalprice");
  var hotsellerTag = $(this).attr("data-taghotseller");
  var outletTag = $(this).attr("data-tagoutlet");
  var dataAvailable = $(this).attr("data-availability");
  var dataPrice = $(this).attr("data-Price");
  var variantID = $(this).attr("data-forimage");
  $('[data-imagevariantid='+variantID+']').attr('src',imageURL);
   $('[data-imageid='+variantID+']').attr('href',variantUrl);
   $('[data-titleVariantid='+variantID+']').text(variantTitle);
  if(dataOriginalPrice!= "$ 0.00")
  {
    $('[data-variantPriceId='+variantID+']').text(dataOriginalPrice);
     $('.ss-sale-price[data-variantSalePriceId='+variantID+']').show();
      $('.originalPrice[data-variantPriceId='+variantID+']').addClass('strikethrough');
     $('[data-variantSalePriceId='+variantID+']').text(dataPrice);
  }else
  {
    $('.originalPrice[data-variantPriceId='+variantID+']').text(dataPrice);
    $('.originalPrice[data-variantPriceId='+variantID+']').removeClass('strikethrough');
    $('.ss-sale-price[data-variantSalePriceId='+variantID+']').hide();
  }
  if(dataAvailable == 'false')
  {
    $('[data-imageId='+variantID+'] > .sold_out_product').remove();
    $('[data-imageId='+variantID+']').parents('.product-item').addClass('product-item--sold-out');
    $('[data-imageId='+variantID+']').append('<div class="sold_out_product ng-scope"><span class="getonthelist">WAITLIST</span></div>'); 
      $('[data-variant_id='+variantID+']').addClass("sold-out");
    $('.hotseller[data-hotseller='+variantID+']').removeClass('displayBlock');
    $('.hotseller[data-hotseller='+variantID+']').addClass('displayNone');
  }else{
     $('[data-imageId='+variantID+']').parents('.product-item').removeClass('product-item--sold-out');
    $('[data-imageId='+variantID+'] > .sold_out_product').remove();
    $('[data-variant_id='+variantID+']').removeClass("sold-out");
      $('.hotseller[data-hotseller='+variantID+']').addClass('displayBlock');
    $('.hotseller[data-hotseller='+variantID+']').removeClass('displayNone');
  }
  if(hotsellerTag == 1 && outletTag == 0)	
  {	
    $('.hotseller[data-hotSeller='+variantID+']').removeClass("displayNone");	
    $('.hotseller[data-hotSeller='+variantID+']').addClass("displayBlock");	
    $('.discount-image[data-priceLabel='+variantID+']').removeClass("displayBlock");	
     $('.discount-image[data-priceLabel='+variantID+']').addClass("displayNone");	
  }
  else if(hotsellerTag == 1 && outletTag == 1)	
  {	
   $('.hotseller[data-hotSeller='+variantID+']').removeClass("displayBlock");	
    $('.hotseller[data-hotSeller='+variantID+']').addClass("displayNone");	
     $('.discount-image[data-priceLabel='+variantID+']').removeClass("displayNone");	
     $('.discount-image[data-priceLabel='+variantID+']').addClass("displayBlock");	
  }else if(hotsellerTag == 0 && outletTag == 1)	
  {	
     $('.hotseller[data-hotSeller='+variantID+']').removeClass("displayBlock");	
    $('.hotseller[data-hotSeller='+variantID+']').addClass("displayNone");	
    $('.discount-image[data-priceLabel='+variantID+']').removeClass("displayNone");	
     $('.discount-image[data-priceLabel='+variantID+']').addClass("displayBlock");	
  }else if(hotsellerTag == 0 && outletTag == 0)
  {	
     $('.hotseller[data-hotSeller='+variantID+']').removeClass("displayBlock");	
   $('.hotseller[data-hotSeller='+variantID+']').addClass("displayNone");	
     $('.discount-image[data-priceLabel='+variantID+']').removeClass("displayBlock");	
      $('.discount-image[data-priceLabel='+variantID+']').addClass("displayNone");	
  }

 //lets process inventory to get x count
  var inventoryEls = mainProductId;
  async function doInventoryAjax(){
    if (inventoryEls.length) {
          var variantId = inventoryEls; 
          var res = await fetch('https://www.reddress.com/products/' + mainProductUrl + "?view=swatch");
          var prodData = await res.json();

      $.each(prodData.swatches , function(index, variant) { 
      
        if(mainProductUrl == variant.handle){
         
          var change_img_url = variant.image.url.replace("_large", "_1000x");
          var change_title = variant.title;
          var price = variant.price;
          var compare_price = variant.originalPrice;

           if(!price.indexOf('.00') > -1){
            price = price + '.00';
           }
           if(!compare_price.indexOf('.00') > -1){
            compare_price = compare_price + '.00';
           }


          if(compare_price>price){
            var change_price = '<span class="price price--highlight"><span class="visually-hidden">Sale price</span>'+price+'</span><span class="price price--compare"><span class="visually-hidden">Regular price</span>'+compare_price+'</span>';
             current.parents('.product-item').find('.price-list').html(change_price);
          }
          else{
            var change_price = '<span class="price"><span class="visually-hidden">Sale price</span>'+price+'</span>';
            current.parents('.product-item').find('.price-list').html(change_price);
          }

            current.parents('.product-item').find('.product-item__primary-image').attr('src',change_img_url);
            current.parents('.product-item').find('.product-item__primary-image').attr('srcset',change_img_url);
            current.parents('.product-item').find('.product-item-meta__title').html(change_title);
            current.parents('.product-item').find('.product_item_swatches li').each(function( index ) {
              var colorSwatchVariantTitle =  $(this).find('a').attr('data-varianttitle');
              if(change_title == colorSwatchVariantTitle){
                $(this).addClass("active");
              }else{
                $(this).removeClass("active");
              }
            });
           
            console.log("change swatch");


         
                  if (variant.productFilterData.variants.length) {
                       var xLeft = 0;
                    
                       $.each(variant.productFilterData.variants, function(index, size_options) { 
                         
                         var xVariant = size_options;
                            if (xVariant.available && xVariant.inventory_management === 'shopify') {
                              xLeft += parseInt(xVariant.inventory_quantity);
                             } 
                       });
                 
                       if (xLeft > 0 && xLeft < 5) {
                       
                        current.parents('.product-item').find('.low-stocks').html('only ' + xLeft + ' left');
                        $('[data-lowstock='+variantId+']').html('only ' + xLeft + ' left');
                        }
                        else{
                           current.parents('.product-item').find('.low-stocks').html('');
                        }
                  }
 
       
        }
      }); 

      
           
    }
  }
  doInventoryAjax();
}); 